module.exports = __webpack_public_path__ + "img/splash-4.2f21c3c6.png";